module.exports = __webpack_public_path__ + "img/tables.96907e78.svg";